import { StatusScreenTypeEnum } from '@qvs/core';

export const statusScreenBannerUrlMap = new Map<StatusScreenTypeEnum, string>([
  [StatusScreenTypeEnum.SUCCESS, 'assets/images/success_banner.svg'],
  [StatusScreenTypeEnum.PENDING, 'assets/images/loading_banner.svg'],
  [StatusScreenTypeEnum.APP_SWITCH, 'assets/images/loading_banner.svg'],
  [StatusScreenTypeEnum.WARNING, 'assets/images/warning_banner.svg'],
  [StatusScreenTypeEnum.FAILED, 'assets/images/error_banner.svg']
]);
